import { clientService } from "@/services/ClientService";
import { toast } from "vue3-toastify";
import { i18n } from "./../lang";

const state = {
    clientData: [],
    isAddingClient: false,
    editingClient: false,
    editClientRequest: {
        loading: false,
    },
    addClientRequest: {
        loading: false,
    },
    getClientsRequest: {
        loading: false
    },
    deleteClientRequest: {
        loading: false,
        message: null
    }
};

const actions = {
    getClientData({commit}){
        commit('setGetClientRequest',{loading: true});
        clientService.getClientData()
            .then((response) => {
                commit('setGetClientRequest', {loading: false});
                commit('updateClient', response.data);
            })
            .catch((error) => {
               commit('setGetClientRequest', {loading: false, message: error});
            });
    },
    async updateClient({commit, state}, {client}){
        commit('setEditClientRequest', {loading: true});

        clientService.updateClient(client)
            .then((response) => {
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setEditClientRequest', {loading: false});
                const updatedClient = state.clientData.map(x => (x.clientDataId ===  client.clientDataId ? client : x));
                commit('updateClient', updatedClient);
                commit('setEditingClient', null);
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit('setEditClientRequest', {loading: false, message: error});
            });
    },
    async addClient({commit, state}, {client}){
        commit('setAddClientRequest', {loading: true});
        return clientService.addClient(client)
            .then((response) => {
                toast.success(i18n.global.t("toast.createSuccess"));
                commit('setAddClientRequest', {loading: false});
                commit('updateClient', [...state.clientData, response.data]);
                commit('setIsAddingClient', false);
                return response.data
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.createError"));
                commit('setAddClientRequest', {loading: false, message: error});
                return false
            })
    },
    async deleteClient({commit, state}, client) {
        commit('setDeleteClientRequest', {loading: true})
        clientService.deleteClient(client)
            .then((response) => {
                const updatedClientData = state.clientData.filter(
                    element => element.clientDataId !== client.clientDataId
                );
                commit('updateClient', updatedClientData)
                commit('setDeleteClientRequest', {loading: false})
                toast.success(i18n.global.t("toast.deleteSuccess"));
            })
            .catch((error) => {
                commit('setDeleteClientRequest', {loading: false, message: error})
                toast.error(i18n.global.t("toast.deleteError"));
            })
    },
    linkClientToAccount({ commit }, { client, accountId, withPopup = true }) {
        return clientService.linkClientToAccount(client, accountId)
            .then((response) => {
                if (withPopup) {
                    toast.success(i18n.global.t("toast.successEdit"));
                }
                return true;
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                return false;
            });
    }
}

const mutations = {
    setEditingClient(state, editingClient){
        state.editingClient = editingClient;
        state.isAddingClient = false;
    },
    setIsAddingClient(state, isAddingClient){
        state.isAddingClient = isAddingClient;
        state.editingClient = null;
    },
    setGetClientRequest(state, {loading, message}){
        state.getClientsRequest = {
            loading: loading,
            message: message
        }
    },
    setAddClientRequest(state, {loading, message}){
        state.addClientRequest = {
            loading: loading,
            message: message
        }
    },
    setEditClientRequest(state, {loading, message}){
        state.editClientRequest = {
            loading: loading,
            message: message
        }
    },
    updateClient(state, newList){
        state.clientData = newList;
    },
    setDeleteClientRequest(state, {loading, message}) {
        state.deleteClientRequest = {
            lading: loading,
            message: message
        }
    }
}

export const client = {
    namespaced: true,
    state,
    actions,
    mutations
};